module.exports = __webpack_public_path__ + "static/17-47f81d1ca9a42b1165069b1faa1a3ef3.jpg";